/** Provides an extra list of available API endpoints */
export enum PosturinnServerApi {
	AccountFamilyMembers = 'my-profile/familymembers',
	AccountProfile = 'accounts/{{accountId}}',
	AddressLookup = 'street-lookup',

	Addresses = 'addresses',
	Countries = 'countries',
	PostalCodes = 'postal-codes',

	PublicShipments = 'shipments/{{shipmentId}}',
	RegisterShipmentForAnonymous = 'shipments',
	FetchPdfForAnonymous = 'shipments/{{shipmentId}}/label',
	FetchPdf = 'accounts/{{accountId}}/shipments/{{shipmentId}}/label',
	PostalDropOption = 'shipments/{{shipmentId}}/postal-drop-options',
	Shipments = 'accounts/{{accountId}}/shipments',
	Shipment = 'accounts/{{accountId}}/shipments/{{shipmentId}}',
	ShipmentCustoms = 'accounts/{{accountId}}/shipments/{{shipmentId}}/customs',
	ShipmentCustomsInfo = 'accounts/{{accountId}}/shipments/{{shipmentId}}/customsInfo',
	ShipmentDetails = 'accounts/{{accountId}}/shipments/{{shipmentId}}/details',
	ShipmentDocument = 'accounts/{{accountId}}/shipments/{{shipmentId}}/documents/{{documentId}}',
	ShipmentDocumentContent = 'accounts/{{accountId}}/shipments/{{shipmentId}}/documents/{{documentId}}/content',
	ShipmentDocuments = 'accounts/{{accountId}}/shipments/{{shipmentId}}/documents',
	ShipmentFees = 'accounts/{{accountId}}/shipments/{{shipmentId}}/fees',
	ShipmentOptions = 'accounts/{{accountId}}/shipments/{{shipmentId}}/options',
	ShipmentUnlockCodes = 'accounts/{{accountId}}/shipments/{{shipmentId}}/parcel-unlock-codes',
	ShipmentTrackingEvents = 'accounts/{{accountId}}/shipments/{{shipmentId}}/tracking-events',
	ShipmentHide = 'accounts/{{accountId}}/shipments/hide',
	ShipmentUnhide = 'accounts/{{accountId}}/shipments/unhide',

	VerifyRecipient = 'verify/recipient',
	VerifyPostalCode = 'verify/postal-code',

	ShipmentDeliveryServiceBrackets = 'shipments/service-brackets',
	ShipmentSingleDeliveryService = 'shipments/delivery-service',

	ProfilePaymentCards = 'accounts/{{accountId}}/payment-cards',
	ProfilePaymentCard = 'accounts/{{accountId}}/payment-cards/{{paymentCardId}}',
	/** @deprecated use PosturinnServerApi.PaymentWithCard */
	ProfilePayWithCard = 'accounts/{{accountId}}/pay/card',
	AccountUsesNewFlow = 'accounts/{{accountId}}/one-time-payment/uses-new-flow',

	PaymentWithCard = 'accounts/{{accountId}}/pay/card',
	PaymentWithCardVerify = 'accounts/{{accountId}}/pay/card/verify',
	PayWithCardChallengeDecidedByIssuer = 'accounts/{{accountId}}/one-time-payment/begin', //new teya flow
	PaymentWithPei = 'accounts/{{accountId}}/pay/pei',
	PaymentWithPeiResendPin = 'accounts/{{accountId}}/pay/pei/pin',
	PaymentWithPeiConfirm = 'accounts/{{accountId}}/pay/pei/confirm',

	GlobalSearch = 'accounts/{{accountId}}/search',
	Search = 'accounts/{{accountId}}/search/{{type}}',

	DeliveryServices = 'shipments/delivery-services',
	DeliveryServiceBrackets = 'shipments/service-brackets',

	Locations = 'locations',
	Location = 'locations/{{locationId}}',
	LocationStatus = 'locations/{{locationId}}/status',

	MyProfile = 'my-profile',
	SendFeedback = 'my-profile/feedback',

	SetGdprTerms = 'account/gdpr-terms/verification',
	AccountEmailRequestVerification = 'account/email/request-verification',
	AccountPhoneNumberRequestVerification = 'account/phone-number/request-verification',
	AccountPhoneNumberCheckVerificationToken = 'account/phone-number/verification/{{verificationId}}',
	Refund = 'accounts/{{accountId}}/refund/info',
	RefundBank = 'accounts/{{accountId}}/refund/bank',
	ChangeShipmentDestination = 'redirect-full-postbox-delivery',

	CompanyReturnEmail = 'accounts/{{accountId}}/shipments/company-return',

	CalculateDuties = 'accounts/{{accountId}}/calculate-duties',
	CalculateDutiesForAnonymous = 'calculate-duties',
}
